// Shared style for top-nav buttons so simple NavLinks (Acasa, Proiecte,
// Abonamente) and dropdown triggers (Proceduri, Resurse) render identically.
export const NAV_BUTTON_BASE =
  'inline-flex items-center gap-1 px-3 py-2 text-sm font-semibold text-gray-700 hover:text-indigo-600 hover:bg-indigo-50 rounded-md transition';

export const NAV_BUTTON_ACTIVE = 'text-indigo-700 bg-indigo-50';
